import { GCInstant as platform } from 'src/lib/gcinstant';
import {
  ChatbotGroup,
  daysConsideredNew,
} from 'src/replicant/chatbot/chatbot.ruleset';
import StateObserver, { user } from 'src/StateObserver';
import { duration } from 'src/replicant/utils/duration';
import { track } from '../analytics/utils';
import { CommonAnalytics } from '@play-co/gcinstant';
import features from 'src/replicant/ruleset/features';

/**
 * Returns the chatbot group of the current user.
 * @param daysOffset Offset in days to add to the daysSinceInstall property.
 */
export function inferChatbotGroup(daysOffset = 0): ChatbotGroup {
  const now = StateObserver.now();
  const { user } = StateObserver.getState();
  const ltv = user.lifetimeValue + user.actualLTV;
  const daysSinceInstall = Math.floor(
    (now - user.createdAt) / duration({ days: 1 }),
  );

  // Consider non tagged users as adults.
  const taggedAsTeen = !(platform.getDemographics().isAdult ?? true);

  // Purchasers will be considered as adults in some cases.
  const isPurchaser = !!ltv;

  // Teens are users who are not adults and are not purchasers.
  const isTeen = taggedAsTeen && !isPurchaser;
  if (isTeen) {
    return 'teen';
  }

  // Resume resurrection OA if the adult has been reactivated in the last 7 days.
  const timeSinceReactivated = now - user.lastReactivationAt;
  if (timeSinceReactivated < duration({ days: daysConsideredNew })) {
    return 'newAdult';
  }

  // Old adults are adults (or teen purchasers) who have been in the game for more than 7 days.
  const isOldAdult =
    Math.floor((daysSinceInstall ?? 0) + daysOffset) >= daysConsideredNew;

  if (isOldAdult) {
    return 'oldAdult';
  }

  // New adults are adults who have been in the game for less than 7 days.
  return 'newAdult';
}
